module.exports = __webpack_public_path__ + "static/media/ice-hockey.20dc9114.webp";